import { AoPath } from './ao-path';
import { PathMarkerBbx } from './path-marker/path-marker-bbx';
import { PathPointBbx } from './path-point/path-point-bbx';

export class AoPathBbx extends AoPath {
  public override pathPoint: PathPointBbx[];
  public override markers: PathMarkerBbx[];
  public override displayedMarkers: PathMarkerBbx[];

  constructor(id: string, date: Date, pathPoint: PathPointBbx[]) {
    super(id, date, pathPoint);
  }

  public override generatePathMarker(pathPoint: PathPointBbx): PathMarkerBbx {
    return new PathMarkerBbx('', pathPoint);
  }
}
